export default {
  model: {
    'activeStorage/attachment': 'Attachment',
    'role': 'Role',
    'customerSource': 'Customer source',
    'user': 'User',
    'userOauthIdentityAccount': 'User oauth identity account',
    'usersRole': 'Users role',
    'application': 'Application',
    'activeStorage/blob': 'Resource',
    'actsAsTaggableOn/tag': 'Tag',
    'operationRecord': 'Operation record',
    'channel': 'Channel',
    'customerLevel': 'Customer level',
    'customerKind': 'Customer kind',
    'customerConnection': 'Customer connection',
    'customerTag': 'Customer tag',
    'customerTransaction': 'Customer transaction',
    'customerBusinessModel': 'Customer business model',
    'productStyle': 'Product style',
    'saleChannel': 'Sale channel',
    'customer': 'Customer',
    'customerJushuitanOrderRelation': 'Customer jushuitan order relation',
    'followKeyItem': 'Follow key item',
    'taskAssignment': 'Task assignment',
    'followRecord': 'Follow record',
    'customerChannel': 'Customer channel',
    'customerBackgroundCheck': 'Customer Background Check',
    'jushuitanShop': 'Jushuitan Shop',
    'jushuitanOrder': 'Jushuitan order',
    'jushuitanAfterSale': 'Jushuitan after sale',
    'notification': 'Notification',
    'memo': 'Memo',
    'customReport': 'Custom report',
    'task': 'Task',
    'jushuitanInventoryOut': 'Jushuitan inventory out',
    'paymentAccount': 'Payment account',
    'paymentAllocation': 'Payment allocation',
    'payment': 'Payment',
    'adjustment': 'Adjustment',
    'paymentReminder': 'Payment Reminder',
    'salesLineItem': 'Sales line item',
    'salesOrderAllocation': 'Sales order allocation',
    'afterSaleAllocation': 'After sale allocation',
    'salesOrder': 'Sales order',
    'feige/product': 'Product',
    'workReport': 'Work report',
    'reports/receivable': 'Receivable',
    'reports/commissionSource': 'Commission source',
    'performanceGoal': 'Performance goal',
    'team': 'Team',
    'operationLog': 'Operation log',
    'billSendRecord': 'Bill send record',
    'banner': 'Banner',
    'customPage': 'Custom page',
    'hotWord': 'Hot word',
    'page': 'Page',
    'presetPage': 'Preset page',
    'profile': 'Profile',
    'roleCore/role': 'Role',
    'staticPage': 'Static page',
    'userGroup': 'User group',
  },
  'activeStorage/attachment': {
    id: 'ID',
    createdAt: 'Created at',
    signedId: 'Signed',
    contentType: 'Content type',
    filename: 'Filename',
    byteSize: 'Byte size',
    url: 'Url',
  },
  'role': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
    kind: 'Kind',
    kinds: {
      super: 'Super',
      application: 'Application',
      business_executive: 'Business executive',
      salesman: 'Salesman',
      channel_business_executive: 'Channel business executive',
      finance: 'Finance',
      customer_service: 'Customer service',
      finance_manager: 'Finance manager',
      custom: 'Custom',
      merchandiser: 'Merchandiser',
    },
    customPermissions: 'Custom permissions',
  },
  'customerSource': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
  },
  'user': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    screenName: 'Screen name',
    isBlock: 'Is block',
    email: 'Email',
    roleId: 'Role',
    creatorId: 'Creator',
    phone: 'Phone',
    avatar: 'Avatar',
    role: 'Role',
    creator: 'Creator',
    customerSourceIds: 'Customer source ids',
    customerSources: 'Customer sources',
    relatedUserIds: 'Related user ids',
    relatedUsers: 'Related users',
    customerCapacityLimit: 'Customer capacity limit',
  },
  'userOauthIdentityAccount': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
  },
  'usersRole': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    roleId: 'Role',
    userId: 'User',
    role: 'Role',
    user: 'User',
  },
  'application': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
    desc: 'Desc',
    shareDesc: 'Share description',
    shareTitle: 'Share title',
    wechatApplicationId: 'Wechat application',
    shareImage: 'Share image',
    logo: 'Logo',
    monthlyReportReceivers: 'Report Recipients',
    purpleShopIds: 'Purple Team Shop IDs',
    leaderboardScrollInterval: 'Leaderboard Scroll Interval',
    customShopIds: 'Custom Business Shop IDs',
    fengPeiShanUserId: 'Feng Peishan User ID',
    fengPeiShanShopIds: 'Feng Peishan Shop IDs',
    dengZhengYaoUserId: 'Deng Zhengyao User ID',
    dengZhengYaoShopIds: 'Deng Zhengyao Shop IDs',
    luoXingYiUserId: 'Luo Xingyi User ID',
    teamLeaderCustomerLimit: 'Team Leader Customer Limit',
    teamMemberCustomerLimit: 'Team Member Customer Limit',
    dateExcludedShopIds: 'Date excluded shop ids',
    dateExcludedCutoffDate: 'Date excluded cutoff date',
    customerPoolOpenDays: 'Customer Pool Open Days',
    customerPoolOpenFromHour: 'Customer Pool Open From Hour',
    customerPoolOpenToHour: 'Customer Pool Open To Hour',
    customerPoolDailyClaimLimit: 'Daily Claim Limit Per Person',
    customerPoolOwnershipRestrictionMonths: 'Ownership Restriction Months',
    customerPoolFollowupHours: 'First Followup Deadline (Hours)',
    customerPoolFollowupWarningLeadHours: 'Followup Warning Lead Hours',
    customerPoolNewRecordNoFollowDays: 'New Record No-Follow Release Days',
    customerPoolNewCustomerNoFollowDays: 'New Customer No-Follow Release Days',
    customerPoolNewCustomerNoOrderDays: 'New Customer No-Order Release Days',
    customerPoolOldCustomerNoFollowDays: 'Old Customer No-Follow Release Days',
    customerPoolOldCustomerNoRepurchaseDays: 'Old Customer No-Repurchase Release Days',
    customerPoolCapacityWarningRatio: 'Capacity Warning Ratio',
    customerPoolReleaseWarningLeadDays: 'Customer pool release warning lead days',
    posterImage: 'Poster image',
  },
  'activeStorage/blob': {
    id: 'ID',
    createdAt: 'Created at',
    signedId: 'Signed',
    contentType: 'Content type',
    filename: 'Filename',
    byteSize: 'Byte size',
    url: 'Url',
    tagList: 'Tag list',
  },
  'actsAsTaggableOn/tag': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
  },
  'operationRecord': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    operatableType: 'Operatable type',
    operatableId: 'Operatable',
    operatorType: 'Operator type',
    operatorId: 'Operator',
    ipAddress: 'Ip address',
    operator: 'Operator',
    operatable: 'Operatable',
    operationDescription: 'Operation description',
    requestPath: 'Request path',
    requestMethod: 'Request method',
    requestParams: 'Request params',
    previousObject: 'Previous object',
    currentObject: 'Current object',
  },
  'channel': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
    orderColumn: 'Order column',
    orderColumns: {
      shop_id: 'Shop',
      buyer_id: 'Buyer',
      open_id: 'Open',
      drp_co_id_from: 'Drp co id from',
    },
  },
  'customerLevel': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
    remindDays: 'Remind days',
    description: 'Description',
    yearlyMinOrderAmount: 'Yearly min order amount',
    yearlyMaxOrderAmount: 'Yearly max order amount',
  },
  'customerKind': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
  },
  'customerConnection': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
  },
  'customerTag': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
  },
  'customerTransaction': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
    stages: 'Stages',
  },
  'customerBusinessModel': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
  },
  'productStyle': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
  },
  'saleChannel': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
  },
  'customer': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
    userId: 'User',
    customerLevelId: 'Customer level',
    customerSourceId: 'Customer source',
    customerKindId: 'Customer kind',
    customerConnectionId: 'Customer connection',
    customerTransactionId: 'Customer transaction',
    createDate: 'Create date',
    manager: 'Manager',
    phone: 'Phone',
    customerLevel: 'Customer level',
    customerLevelFixed: 'Customer level fixed',
    tradeHeat: 'Trade heat',
    last7DayOrderQty: 'Last 7 day order qty',
    last7DayOrderAmount: 'Last 7 day order amount',
    last30DayOrderQty: 'Last 30 day order qty',
    last30DayOrderAmount: 'Last 30 day order amount',
    lastMonthOrderQty: 'Last month order qty',
    lastMonthOrderAmount: 'Last month order amount',
    user: 'User',
    customerSource: 'Customer source',
    customerKind: 'Customer kind',
    customerConnection: 'Customer connection',
    customerTags: 'Customer tags',
    customerTransaction: 'Customer transaction',
    customerBusinessModels: 'Customer business models',
    productStyles: 'Product styles',
    saleChannels: 'Sale channels',
    customerBusinessModelIds: 'Customer business model ids',
    productStyleIds: 'Product style ids',
    saleChannelIds: 'Sale channel ids',
    customerTagIds: 'Customer tag ids',
    needSupplementInformation: 'Need supplement information',
    lastFollowRecordOfUserFollowedAt: 'Last follow record of user followed at',
    assignToUser: 'Assign to user',
    restAmount: 'Rest amount',
    annualStatusList: 'Annual status list',
    annualStatusManual: 'Annual status manual',
    newCustomerInCurrentYear: 'New customer in current year',
    poolReleasedReason: 'Pool released reason',
    poolReleasedUserId: 'Pool released user',
    poolReleasedUser: 'Pool released user',
    poolEnteredAt: 'Pool entered at',
    poolDays: 'Pool days',
    latestEffectiveFollowedAt: 'Latest effective followed at',
    latestOrderedOn: 'Latest ordered on',
    address: 'Address',
    wechat: 'Wechat',
    hasProductionCapacity: 'Has production capacity',
    hasDesignCapability: 'Has design capability',
    pricePreference: 'Price preference',
    inquiryContent: 'Inquiry content',
    brand: 'Brand',
    salesAbility: 'Sales ability',
    customerJushuitanOrderRelations: 'Customer jushuitan order relations',
    followRecords: 'Follow records',
    files: 'Files',
    negotiationForm: 'Negotiation form',
  },
  'customerJushuitanOrderRelation': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    jushuitanOrderKey: 'Jushuitan order key',
    jushuitanOrderForeignKey: 'Jushuitan order foreign key',
    jushuitanOrderForeignKeys: {
      drp_co_id_from: 'Drp co id from',
      open_id: 'Open',
      buyer_id: 'Buyer',
      shop_id: 'Shop',
      shop_buyer_id: 'Shop buyer',
    },
    jushuitanOrderForeignKeyValue: 'Jushuitan order foreign key value',
    customer: 'Customer',
  },
  'followKeyItem': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
    isEffectiveFollow: 'Is effective follow',
  },
  'taskAssignment': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    assigneeId: 'Assignee',
    state: 'State',
    states: {
      pending: 'Pending',
      processing: 'Processing',
      completed: 'Completed',
    },
    reply: 'Reply',
    taskTitle: 'Task title',
    taskId: 'Task',
    assignee: 'Assignee',
    customersCount: 'Customers count',
    followedCustomersCount: 'Followed customers count',
    followRatio: 'Follow ratio',
    followRecords: 'Follow records',
    followedCustomers: 'Followed customers',
    unfollowedCustomers: 'Unfollowed customers',
  },
  'followRecord': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    customerId: 'Customer',
    userId: 'User',
    followedAt: 'Followed at',
    taskAssignmentId: 'Task assignment',
    customer: 'Customer',
    content: 'Content',
    user: 'User',
    media: 'Media',
    followKeyItemIds: 'Follow key item ids',
    followKeyItems: 'Follow key items',
    taskAssignment: 'Task assignment',
  },
  'customerChannel': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    no: 'No',
    channelId: 'Channel',
    customerId: 'Customer',
    channel: 'Channel',
    customer: 'Customer',
  },
  'customerBackgroundCheck': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    customerId: 'Customer',
    submitterId: 'Submitter',
    status: 'Status',
    statuses: {
      pending: 'Pending',
      processing: 'Processing',
      completed: 'Completed',
      failed: 'Failed',
    },
    completedAt: 'Completed At',
    submitter: 'Submitter',
    startedAt: 'Started At',
    errorMessage: 'Error Message',
    result: 'Result',
  },
  'jushuitanShop': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    shopId: 'Shop ID',
    shopName: 'Shop Name',
    shopType: 'Shop Type',
    shopTypes: {
      online: 'Online Shop',
      offline: 'Offline Shop',
    },
  },
  'jushuitanOrder': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    oId: 'O',
    soId: 'So',
    shopId: 'Shop',
    status: 'Status',
    modified: 'Modified',
    key: 'Key',
    created: 'Created',
    amount: 'Amount',
    customer: 'Customer',
    user: 'User',
    userId: 'User',
    customerId: 'Customer',
    payAmount: 'Pay amount',
    shopName: 'Shop name',
    shopSite: 'Shop site',
    items: 'Items',
    freight: 'Freight',
    logisticsCompany: 'Logistics company',
    remark: 'Remark',
    buyerMessage: 'Buyer message',
    shopBuyerId: 'Shop buyer',
    freeAmount: 'Free amount',
    sentAt: 'Sent at',
    paidAmount: 'Paid amount',
    orderDate: 'Order date',
    shop: 'Shop',
    canEditKey: 'Can edit key',
    canBindCustomer: 'Can bind customer',
    canUnbindCustomer: 'Can unbind customer',
    receivableAmount: 'Receivable amount',
    receivedAmount: 'Received amount',
    isEven: 'Is even',
    realFreight: 'Real freight',
    lId: 'L',
    outAmount: 'Out amount',
    receiveIgnored: 'Receive ignored',
  },
  'jushuitanAfterSale': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    asId: 'As',
    outerAsId: 'Outer as',
    soId: 'So',
    status: 'Status',
    modified: 'Modified',
    created: 'Created',
    refund: 'Refund',
    realRefund: 'Real refund',
    receivableAmount: 'Receivable amount',
    receivedAmount: 'Received amount',
    order: 'Order',
    shop: 'Shop',
    payment: 'Payment',
    items: 'Items',
    confirmDate: 'Confirm date',
  },
  'notification': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    actorType: 'Actor type',
    actorId: 'Actor',
    targetType: 'Target type',
    targetId: 'Target',
    kind: 'Kind',
    kinds: {
      pick_customer: 'Pick customer',
      release_customer: 'Release customer',
      assign_customer: 'Assign customer',
      pool_assign_customer: 'Pool assign customer',
      apply_assign_customer: 'Apply assign customer',
      cancel_apply_assign_customer: 'Cancel apply assign customer',
      approve_assign_customer: 'Approve assign customer',
      reject_assign_customer: 'Reject assign customer',
      fill_customer_info_remind: 'Fill customer info remind',
      follow_customer_remind: 'Follow customer remind',
      memo_remind: 'Memo remind',
      follow_customers_remind: 'Follow customers remind',
      update_approved_payment: 'Update approved payment',
      cancel_finished_sales_order: 'Cancel finished sales order',
      payment_remind: 'Payment remind',
      customer_pool_opening: 'Customer pool opening',
      customer_claim_followup_due: 'Customer claim followup due',
      customer_capacity_warning: 'Customer capacity warning',
      customer_claim_timeout_returned: 'Customer claim timeout returned',
      customer_release_warning: 'Customer release warning',
    },
    isRead: 'Is read',
    actor: 'Actor',
    target: 'Target',
    extra: 'Extra',
  },
  'memo': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    content: 'Content',
    remindAt: 'Remind at',
    customerId: 'Customer',
    isReminded: 'Is reminded',
    customer: 'Customer',
  },
  'customReport': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    targetType: 'Target type',
    kind: 'Kind',
    kinds: {
      monthly: 'Monthly',
      weekly: 'Weekly',
      daily: 'Daily',
    },
    targetId: 'Target',
    startAt: 'Start at',
    endAt: 'End at',
    ownerType: 'Owner type',
    ownerId: 'Owner',
    data: 'Data',
    target: 'Target',
    owner: 'Owner',
  },
  'task': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    creatorId: 'Creator',
    title: 'Title',
    content: 'Content',
    filters: 'Filters',
    displayFilters: 'Display filters',
    creator: 'Creator',
    taskAssignments: 'Task assignments',
    assigneeIds: 'Assignee ids',
    customersCount: 'Customers count',
    followedCustomersCount: 'Followed customers count',
    followRatio: 'Follow ratio',
  },
  'jushuitanInventoryOut': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    soId: 'So',
    status: 'Status',
    ioId: 'Io',
    oId: 'O',
    shopId: 'Shop',
    modified: 'Modified',
    order: 'Order',
    shop: 'Shop',
    kind: 'Kind',
    kinds: {
      sync: 'Sync',
      custom: 'Custom',
    },
    orderType: 'Order type',
    payAmount: 'Pay amount',
    ioDate: 'Io date',
    paidAmount: 'Paid amount',
    freeAmount: 'Free amount',
    freight: 'Freight',
    items: 'Items',
    payDate: 'Pay date',
    logisticsCompany: 'Logistics company',
    lId: 'L',
  },
  'paymentAccount': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
    code: 'Code',
    position: 'Position',
    state: 'State',
    states: {
      active: 'Active',
      inactive: 'Inactive',
    },
    remark: 'Remark',
    canDestroy: 'Can destroy',
    taxRate: 'Tax rate',
  },
  'paymentAllocation': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    paymentId: 'Payment',
    payableId: 'Payable',
    payableType: 'Payable type',
    amount: 'Amount',
    payment: 'Payment',
    payable: 'Payable',
  },
  'payment': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    paymentAccountId: 'Payment account',
    number: 'Number',
    serialNumber: 'Serial number',
    amount: 'Amount',
    auditorId: 'Auditor',
    creatorId: 'Creator',
    customerId: 'Customer',
    kind: 'Kind',
    kinds: {
      deposit: 'Deposit',
      payment: 'Payment',
    },
    state: 'State',
    states: {
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
    },
    paidOn: 'Paid on',
    image: 'Image',
    paymentAccount: 'Payment account',
    auditor: 'Auditor',
    creator: 'Creator',
    customer: 'Customer',
    paymentAllocations: 'Payment allocations',
    unallocatedAmount: 'Unallocated amount',
    isEven: 'Is even',
    remark: 'Remark',
  },
  'adjustment': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    adjustableType: 'Adjustable type',
    amount: 'Amount',
    adjustableId: 'Adjustable',
    creatorId: 'Creator',
    remark: 'Remark',
    adjustable: 'Adjustable',
    creator: 'Creator',
  },
  'paymentReminder': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    salesOrderId: 'Sales Order',
    salesOrder: 'Sales Order',
    stageIndex: 'Stage',
    percentage: 'Percentage',
    amount: 'Amount',
    date: 'Date',
    state: 'State',
    states: {
      pending: 'Pending',
      received: 'Received',
      overdue: 'Overdue',
    },
    daysUntilDue: 'Days Until Due',
    lastNotifiedAt: 'Last Notified At',
  },
  'salesLineItem': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    salesOrderId: 'Sales order',
    styleNumber: 'Style number',
    cost: 'Cost',
    costPrice: 'Cost price',
    price: 'Price',
    quantity: 'Quantity',
    fullyShipped: 'Fully shipped',
    shippedInfo: 'Shipped info',
  },
  'salesOrderAllocation': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    sourceId: 'Source',
    targetId: 'Target',
    amount: 'Amount',
    allocatedOn: 'Allocated on',
    source: 'Source',
    target: 'Target',
  },
  'afterSaleAllocation': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    salesOrderId: 'Sales order',
    jushuitanAfterSaleId: 'Jushuitan after sale',
    receivedAmount: 'Received amount',
    salesOrder: 'Sales order',
    jushuitanAfterSale: 'Jushuitan after sale',
  },
  'salesOrder': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    number: 'Number',
    customerId: 'Customer',
    kind: 'Kind',
    kinds: {
      sample: 'Sample',
      bulk: 'Bulk',
      after_sale: 'After sale',
    },
    userId: 'User',
    isTransferExisting: 'Is transfer existing',
    orderedOn: 'Ordered on',
    productType: 'Product type',
    productTypes: {
      custom: 'Custom',
      stock: 'Stock',
    },
    businessKind: 'Business kind',
    businessKinds: {
      custom: 'Custom',
      wholesale: 'Wholesale',
    },
    sourceId: 'Source',
    salesAmount: 'Sales amount',
    customer: 'Customer',
    user: 'User',
    source: 'Source',
    paymentReminders: 'Payment reminders',
    salesLineItems: 'Sales line items',
    jushuitanOrderIds: 'Jushuitan order ids',
    jushuitanOrders: 'Jushuitan orders',
    tax: 'Tax',
    cost: 'Cost',
    profit: 'Profit',
    fullyShipped: 'Fully shipped',
    sentJushuitanOrders: 'Sent jushuitan orders',
    jushuitanOrdersAmount: 'Jushuitan orders amount',
    jushuitanOrdersRealFreight: 'Jushuitan orders real freight',
    confirmedJushuitanAfterSales: 'Confirmed jushuitan after sales',
    jushuitanAfterSalesAmount: 'Jushuitan after sales amount',
    adjustments: 'Adjustments',
    adjustmentsAmount: 'Adjustments amount',
    remainingAmount: 'Remaining amount',
    receivableAmount: 'Receivable amount',
    unreceivedReceivableAmount: 'Unreceived receivable amount',
    paymentAllocations: 'Payment allocations',
    paymentAllocationsFromJushuitanOrders: 'Payment allocations from jushuitan orders',
    receivedAmount: 'Received amount',
    isEven: 'Is even',
    finishedOn: 'Finished on',
    remark: 'Remark',
    salesOrderAllocationsAmount: 'Sales order allocations amount',
    salesOrderAllocationsAsSource: 'Sales order allocations as source',
    salesOrderAllocationsAsTarget: 'Sales order allocations as target',
    afterSaleAllocations: 'After sale allocations',
  },
  'feige/product': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    styleNumber: 'Style number',
    salesPrice: 'Sales price',
    minOrderQty: 'Min order qty',
  },
  'workReport': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    userId: 'User',
    date: 'Date',
    content: 'Content',
    plan: 'Plan',
    inquiryContent: 'Inquiry content',
    files: 'Files',
    user: 'User',
    followRecords: 'Follow records',
  },
  'reports/receivable': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
    shopNames: 'Shop names',
    shopBuyerId: 'Shop buyer',
    userScreenName: 'User screen name',
    isEven: 'Is even',
    overdue: 'Overdue',
    overdueAmount: 'Overdue amount',
    receivedAmount: 'Received amount',
    receivableAmount: 'Receivable amount',
    unreceivedReceivableAmount: 'Unreceived receivable amount',
    latestBillSendRecordSentAt: 'Latest bill send record sent at',
    latestBillSendRecordConfirmedAt: 'Latest bill send record confirmed at',
  },
  'reports/commissionSource': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    screenName: 'Screen name',
    afterSaleSalesOrderAmount: 'After sale sales order amount',
    receivedAmount: 'Received amount',
    receivableAmount: 'Receivable amount',
    tax: 'Tax',
    freight: 'Freight',
    cost: 'Cost',
    profit: 'Profit',
    salesOrders: 'Sales orders',
  },
  'performanceGoal': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    finishTarget: 'Finish target',
    salesTarget: 'Sales target',
    shippingTarget: 'Shipping target',
    creatorId: 'Creator',
    userId: 'User',
    startOn: 'Start on',
    goalType: 'Goal type',
    goalTypes: {
      monthly: 'Monthly',
      weekly: 'Weekly',
      half_yearly: 'Half yearly',
    },
    user: 'User',
    creator: 'Creator',
  },
  'team': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
    kind: 'Kind',
    kinds: {
      normal: 'Normal',
      purple: 'Purple',
      golden: 'Golden',
    },
    color: 'Color',
    leader: 'Leader',
    merchandiser: 'Merchandiser',
    parent: 'Parent',
    teamMembers: 'Team members',
    childrenCount: 'Children count',
    children: 'Children',
  },
  'operationLog': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    event: 'Event',
    operatorType: 'Operator type',
    targetType: 'Target type',
    operatorId: 'Operator',
    targetId: 'Target',
    data: 'Data',
    operator: 'Operator',
    target: 'Target',
  },
  'billSendRecord': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    customerId: 'Customer',
    senderId: 'Sender',
    sendMethod: 'Send method',
    sentAt: 'Sent at',
    state: 'State',
    states: {
      pending: 'Pending',
      confirmed: 'Confirmed',
    },
    customer: 'Customer',
    sender: 'Sender',
    confirmedAt: 'Confirmed at',
    confirmedBy: 'Confirmed by',
    confirmedIp: 'Confirmed ip',
    file: 'File',
  },
  'banner': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    target: 'Target',
    position: 'Position',
    pagePosition: 'Page position',
    pagePositions: {
      event: 'Event',
    },
    kind: 'Kind',
    kinds: {
      web_link: 'Web link',
      image: 'Image',
      mp_link: 'Mini program link',
    },
    alt: 'Alt',
    image: 'Image',
  },
  'customPage': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    title: 'Title',
    slug: 'Slug',
    default: 'Default',
    miniProgramPath: 'Mini program path',
    publishedAt: 'Published at',
    formalCustomPageId: 'Formal custom page',
    formalCustomPage: 'Formal custom page',
    canRollbackData: 'Can rollback data',
    configs: 'Configs',
  },
  'hotWord': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
    position: 'Position',
    applicationId: 'Application',
    application: 'Application',
  },
  'page': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    slug: 'Slug',
    title: 'Title',
    type: 'Type',
    applicationId: 'Application',
    viewsCount: 'Views count',
    publishedAt: 'Published at',
    wxacode: 'Wxacode',
    content: 'Content',
  },
  'presetPage': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    title: 'Title',
    slug: 'Slug',
    viewsCount: 'Views count',
    content: 'Content',
  },
  'profile': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    gender: 'Gender',
    genders: {
      unknown: 'Unknown',
      male: 'Male',
      female: 'Female',
    },
  },
  'roleCore/role': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
    kind: 'Kind',
    customPermissions: 'Custom permissions',
  },
  'staticPage': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    title: 'Title',
    slug: 'Slug',
    status: 'Status',
    viewsCount: 'Views count',
    wxacode: 'Wxacode',
    content: 'Content',
  },
  'userGroup': {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
    performanceGoalTargets: 'Performance goal targets',
  },
}
